export * from './app-footer.component';



// WEBPACK FOOTER //
// /var/www/midac/midac-live/app/src/app/components/app-footer/index.ts